<template>
    <div class="article__item article-item--border">
        <div class="news__item-inner">
            <div class="news__header-block">
                <template v-if="logo">
                    <img class='news__item-image' :src="logo" alt="#">
                </template>

                <template v-else>
                    <div class='news__item-image'></div>
                </template>

                <a :href="externalLink" class="news__item-link news__item-link--pt news__item-link--hidden" target="_blank" @click="incAmountViews(article.id)">
                    <svg width="17" height="17">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-export"></use>
                    </svg>
                </a>
            </div>
        </div>

        <div class="article__item-content article__item-content--pt">
            <a :href="externalLink" class="news__item-content" target="_blank" @click="incAmountViews(article.id)">
                {{ article.title }}
            </a>
        </div>
    </div>
</template>

<script>
import helper from "../../mixins/helper";
import {mapActions} from "vuex";

export default {
    name: "NewsMainPage",
    mixins: [helper],
    props: {
        article: {
            type: Object,
            required: true
        }
    },
    methods: {
        ...mapActions('news', [
            'incAmountViews'
        ]),
    },
    computed: {
        logo() {
            return this.article.photo ? this.article.photo.url : null;
        },
        externalLink() {
            return this.article.external_link
                ? this.article.external_link
                : "/";
        }
    }
}
</script>
